function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import ActionsFormsSubmit from "../../actions/forms/submit";
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      url: null,
      params: null,
      parentStyles: {},
      formElement: null,
      submitButtons: [],
      modifiedSpec: {}
    };
  },
  watch: {
    $isBusy: function $isBusy(val, oldVal) {
      var _iterator = _createForOfIteratorHelper(this.submitButtons),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var button = _step.value;
          button._isBusy = val;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  },
  methods: {
    $mounted: function $mounted() {
      var _this = this;

      this.$onEvent("forms/addSubmit", function (e) {
        _this.submitButtons.push(e.data);
      });
      this.$onEvent("forms/setBusy", function (e) {
        if (e.data.value) {
          Utils.http.startIndicator(_this);
        } else {
          Utils.http.stopIndicator(_this);
        }
      });
      this.$onEvent("forms/submit", function (e) {
        _this.submit();
      });
      this.$onEvent("forms/directSubmit", function (e) {
        _this.directSubmit(e.data.url);
      });
    },
    $ready: function $ready() {
      this.formElement = this.$refs.form.$el;
      this.parentStyles = this.genericStyles({
        width: this.spec.width
      });

      var _Utils$url$extractFor = Utils.url.extractFormActionData(this.spec.url, this.spec.local),
          url = _Utils$url$extractFor.url,
          params = _Utils$url$extractFor.params;

      this.url = url;
      this.params = params;
      var firstAutoFocus = false;
      this.modifiedSpec = this.spec;
      this.modifiedSpec.childViews.map(function (childView) {
        if (childView.view.startsWith("fields/") && childView.view !== "fields/hidden-v1" && !firstAutoFocus) {
          childView.autoFocus = true;
          firstAutoFocus = true;
        }

        return childView;
      });
    },
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      this.submit();
    },
    submit: function submit() {
      var _this2 = this;

      this.validate(function () {
        Utils.type.ifObject(_this2.spec.onSubmit, function (onSubmit) {
          var formData = Utils.url.toMap(new FormData(_this2.formElement));

          var params = _defineProperty({}, _this2.spec.paramNameForFormData || "formData", formData);

          var data = Object.assign({}, onSubmit, params);
          GLib.action.execute(data, _this2);
        }, function () {
          _this2.directSubmit();
        });
      });
    },
    directSubmit: function directSubmit() {
      var _this3 = this;

      var overrideUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (overrideUrl) {
        GLib.form.submitData(this.formElement, this, overrideUrl);
      } else {
        this.validate(function () {
          GLib.form.submitData(_this3.formElement, _this3);
        });
      }
    },
    validate: function validate(onPassed) {
      if (this.$refs.form.validate()) {
        // Remove focus from current input field to avoid double submit if the user presses ENTER again.
        document.activeElement.blur();
        onPassed();
      } else {
        Utils.launch.dialog.alert("Make sure all fields are valid", this);
      }
    },
    action_clear: function action_clear() {
      this.formElement.reset();
    } // $dialogContainer() {
    //   return this.formElement;
    // }

  }
};